/**
 * Format a world-space distance for HUD/map display using a light-second
 * scale (1 Ls = 1000 game units). For tight distances we keep "u" so the
 * label reads cleanly when the player is hugging an asteroid.
 */
export function formatDistance(distance: number): string {
  if (distance < 1000) return `${Math.round(distance)} u`;
  return `${(distance / 1000).toFixed(2)} Ls`;
}
